import React from 'react';

export const Link = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1214 2.80882C15.2929 1.63725 17.1924 1.63725 18.364 2.80882L21.1924 5.63725C22.364 6.80882 22.364 8.70832 21.1924 9.87989L16.9498 14.1225C16.5593 14.5131 15.9261 14.5131 15.5356 14.1225C15.145 13.732 15.145 13.0988 15.5356 12.7083L19.7782 8.46567C20.1687 8.07515 20.1687 7.44199 19.7782 7.05146L16.9498 4.22303C16.5593 3.83251 15.9261 3.83251 15.5356 4.22303L11.2929 8.46567C10.9024 8.8562 10.2692 8.8562 9.87871 8.46567C9.48819 8.07515 9.48819 7.44199 9.87871 7.05146L14.1214 2.80882ZM9.87871 21.1936C8.70714 22.3652 6.80765 22.3652 5.63607 21.1936L2.80765 18.3652C1.63607 17.1936 1.63608 15.2941 2.80765 14.1225L7.05029 9.87989C7.44081 9.48936 8.07398 9.48936 8.4645 9.87989C8.85503 10.2704 8.85503 10.9036 8.4645 11.2941L4.22186 15.5367C3.83134 15.9273 3.83134 16.5604 4.22186 16.951L7.05029 19.7794C7.44081 20.1699 8.07398 20.1699 8.4645 19.7794L12.7071 15.5367C13.0977 15.1462 13.7308 15.1462 14.1214 15.5367C14.5119 15.9273 14.5119 16.5604 14.1214 16.951L9.87871 21.1936ZM14.8285 9.17278C14.4379 8.78226 13.8048 8.78226 13.4142 9.17278L9.17161 13.4154C8.78108 13.8059 8.78108 14.4391 9.17161 14.8296C9.56213 15.2202 10.1953 15.2202 10.5858 14.8296L14.8285 10.587C15.219 10.1965 15.219 9.56331 14.8285 9.17278Z"
      fill="currentColor"
    />
  </svg>
);
